<template>
  <div class="container">
    <!-- 轉盤 -->
    <div class="lucky-wheel">
      <div class="lucky-title">
        <b-button
          class="detail"
          pill
          variant="warning"
          size="sm"
          @click="clickDetail"
        >{{ showDetail ? "返回抽獎" : "中獎紀錄" }}</b-button>
      </div>
      <div v-if="showDetail" class="detal-region">
        <template v-if="winningRecord.length">
          <b-row
            class="cus-row"
            align-v="center"
            v-for="(item, index) in winningRecord"
            :key="index"
          >
            <b-col cols="4" class="col-date text-center p-1">
              {{
              item.createTime
              }}
            </b-col>
            <b-col cols="5" class="col-comment p-1">
              {{
              prizeList.find((p) => p.id === item.prizeId).name
              }}
            </b-col>
            <b-col
              cols="2"
              class="col-profit text-right p-1"
              :style="item.done ? 'color:lime; font-weight:bold' : 'color:red; font-weight:bold'"
            >{{ item.done ? "已發送" : "處理中" }}</b-col>
          </b-row>
        </template>
        <template v-else>目前無資料</template>
      </div>
      <div v-else class="wheel-main">
        <div class="point"></div>
        <div class="wheel-pointer" @click="draw()"></div>
        <div class="wheel-bg" :style="rotateStyle">
          <div class="wheel-bg-img" :style="bgImgStyle">
            <div class="prize-list">
              <div
                class="prize-item"
                v-for="(item, index) in prizeList"
                :key="index"
                :style="item.style"
              >
                <div class="prize-type">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="count">
      剩餘{{ count }}次
    </div>
    <div class="showID">
      {{ user.clubGGId }}
    </div>

    <!-- 開獎結果 -->
    <b-modal style="z-index: 1032" id="result_modal" ok-only hide-header @hidden="closeMsg">
      <template v-if="cusMsg.length == 0">
        <p>恭喜獲得「{{ prize.name }}」!!!</p>
        <p>獎項會直接打入 FishPoker ID: {{ user.clubGGId }} 帳號</p>
        <p>(獎品發送日：每週三)</p>
      </template>
      <template v-else>
        <p v-for="(item, index) in cusMsg" :key="index">{{ item }}</p>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

const CIRCLE_ANGLE = 360;
const config = {
  // 总旋转时间
  duration: 5000,
  // 旋转圈数
  circle: 4,
  mode: "ease-in-out"
};
export default {
  props: {
    liffAccessToken: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.getPrize();
    this.getDrawCnt();
  },
  data() {
    return {
      count: 0, // 剩余抽奖次数
      duration: 3000, // 转盘旋转时间
      prizes: [],
      prizeList: [], // 奖品列表
      rotateAngle: 0, // 旋转角度
      playing: false,
      index: 0,
      prize: [{ name: "4141" }, { name: "銘謝惠顧" }],
      // btnShow: false,
      bgImgStyle: {
        backgroundImage: `url(${require("@/assets/lotto/wheel_6.png")})`
      },
      // dismissSecs: 5,
      // dismissCountDown: 0,
      result: [String, Number],
      cusMsg: [],
      showDetail: false,
      winningRecord: [],
      user: {}
    };
  },
  created() {
    // 初始化一些值
    this.angleList = [];
    // 是否正在旋转
    this.isRotating = false;
    // 基本配置
    this.config = config;
  },
  computed: {
    rotateStyle() {
      return `
        -webkit-transition: transform ${this.config.duration}ms ${this.config.mode};
        transition: transform ${this.config.duration}ms ${this.config.mode};
        -webkit-transform: rotate(${this.rotateAngle}deg);
        transform: rotate(${this.rotateAngle}deg);
      `;
    }
  },
  methods: {
    getPrize() {
      axios({
        method: "get",
        url: "/prize/list",
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      })
        .then(res => {
          this.prizes = res.data.prizes;
          // 获取奖品列表
          this.prizeList = this.formatPrizeList(this.prizes);
        })
        .catch(_error => {
          this.prizes = [
            {
              id: "001",
              name: "NT$1,000",
              type: "type1",
              amount: "amount1",
              createTime: "2022-01-01"
            },
            {
              id: "001555",
              name: "name555551",
              type: "type1",
              amount: "amount1",
              createTime: "2022-01-01"
            },
            {
              id: "001",
              name: "name1",
              type: "type1",
              amount: "amount1",
              createTime: "2022-01-01"
            },
            {
              id: "002",
              name: "name2",
              type: "type2",
              amount: "amount2",
              createTime: "2022-02-02"
            }
          ];
          console.log("test data");
          console.log(this.prizes);
          // 获取奖品列表
          this.prizeList = this.formatPrizeList(this.prizes);
        });
    },

    getWinningRecord() {
      axios({
        method: "get",
        url: "/prize/listWinningRecord",
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      }).then(res => {
        this.winningRecord = res.data.records;
        // alert(`res: ${JSON.stringify(res.data.records)}`);
      });
    },

    getDrawCnt() {
      axios({
        method: "get",
        url: "/user/get",
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      }).then(res => {
        this.count = res.data.user.drawCnt;
        this.user = res.data.user;
      });
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

    showAlert() {
      this.dismissCountDown = this.dismissSecs;
      this.btnShow = true;
    },

    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },

    formatPrizeList(list) {
      // 记录每个奖的位置
      const angleList = [];
      const l = list.length;
      // 计算单个奖项所占的角度
      const average = CIRCLE_ANGLE / l;
      const half = average / 2;
      // 循环计算给每个奖项添加style属性
      list.forEach((item, i) => {
        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        const angle = -(i * average + half);
        // 增加 style
        item.style = `
					-webkit-transform: rotate(${angle}deg);
					transform: rotate(${angle}deg);
				`;
        // 记录每个奖项的角度范围
        angleList.push(i * average + half);
      });
      this.angleList = angleList;
      // console.debug(angleList);
      // let r = this.getRandomInt(2)

      // let a = 360 / angleList.length

      this.bgImgStyle = {
        backgroundImage: `url(${require(`@/assets/lotto/wheel_${l.toString()}.png`)})`
      };

      return list;
    },

    draw() {
      if (this.count === 0 || this.isRotating || this.playing) {
        if (this.isRotating || this.playing) {
          return;
        } else {
          let msg = [
            "目前額度為0，獲得抽獎方式如下",
            "遊玩任一場現金桌/AoF/大波蘿/急速桌(滿10手即可)",
            "「一周只能累積一次」",
            "每周日24:00結算，周二重置"
          ];
          this.showMsg(msg);
          return;
        }
      }

      this.dismissCountDown = 0;
      this.playing = true;

      axios({
        method: "post",
        url: "/prize/draw",
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      })
        .then(({ data }) => {
          this.result = data.prize;
          this.count = data.drawCnt;

          this.index = this.prizeList.findIndex(p => p.id === this.result.id);
          if (this.index === -1) {
            alert("系統異常，請稍後再試");
            return;
          }

          this.startRotate();
        })
        .catch(err => {
          alert(err);
        });
    },

    random(max, min = 0) {
      return parseInt(Math.random() * (max - min + 1) + min);
    },

    startRotate() {
      const { isRotating, angleList, config, rotateAngle, index } = this;
      if (isRotating) return;
      this.isRotating = true;

      // 计算角度
      const angle =
        // 初始角度
        rotateAngle +
        // 多旋转的圈数
        config.circle * CIRCLE_ANGLE +
        // 奖项的角度
        angleList[index] -
        (rotateAngle % CIRCLE_ANGLE);

      this.rotateAngle = angle;

      // 旋转结束后，允许再次触发
      setTimeout(() => {
        this.stopRotate();
      }, config.duration + 1000);
    },

    stopRotate() {
      this.isRotating = false;
      this.prize = this.prizeList[this.index];
      this.$bvModal.show("result_modal");
      this.playing = false;
      // this.showAlert();
    },
    showMsg(msg) {
      this.cusMsg = msg;
      this.$bvModal.show("result_modal");
    },
    closeMsg() {
      this.cusMsg = [];
    },
    clickDetail() {
      if (!this.showDetail) {
        this.getWinningRecord();
      }
      this.showDetail = !this.showDetail;
    }
  }
};
</script>

<style scoped lang='less'>
.container {
  background-image: url("../assets/lotto/lucky_bg.png");
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  padding: 0;
  z-index: 1031;
  transition: all 0.6s;
}
.detal-region {
  //   font-size: 1.2rem;
  color: white;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 12rem;
  width: 100%;
  transform: scale(0.9);
  transform-origin: top;
}
.lucky-wheel {
  width: 100%;
  background-size: 100%;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.lucky-title {
  position: relative;
  background: url("../assets/lotto/lucky_title.png") no-repeat center top;
  width: 90%;
  max-width: 20rem;
  height: 11rem;
  background-size: 90%;
}
.wheel-main {
  margin: 0 auto;
  position: relative;
  width: 300px;
  height: 300px;
  transform: scale(0.68);
  transform-origin: top;
}
.wheel-bg-img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  // background: url('../assets/lotto/pw_6.png') no-repeat center top;
  border-radius: 100%;
  background-size: 100%;
  color: #fff;
}
.wheel-bg {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  // background: url('../assets/lotto/pw_6.png') no-repeat center top;
  border-radius: 100%;
  background-size: 100%;
  color: #fff;
}
.point {
  position: absolute;
  top: 50%;
  left: 147px;
  z-index: 2;
  width: 340px;
  height: 340px;
  background: url("../assets/lotto/wheel_boarder2.png") no-repeat center top;
  background-size: 100%;
  transform: translate3d(-50%, -50%, 0);
}
.wheel-pointer {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  width: 110px;
  height: 130px;
  background: url("../assets/lotto/wheel_center2.png") no-repeat center top;
  background-size: 100%;
  transform: translate3d(-50%, -50%, 0);
}
.wheel-bg div {
  text-align: center;
}
.prize-list {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: darksalmon conic-gradient(darksalmon 120deg, yellow 120deg 240deg, blue 240deg); */
  border-radius: 100%;
}
.prize-list .prize-item {
  position: absolute;
  width: 95px;
  height: 150px;
  left: 50%;
  margin-left: -47.5px;
  transform-origin: 50% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.prize-pic img {
  width: 4.0625rem;
  height: 2.5rem;
  margin-top: 1.5625rem;
}
.prize-count {
  font-size: 0.875rem;
}
.prize-type {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 30px;
  color: black;
  writing-mode: vertical-lr;
  word-wrap: break-word;
  height: 100px;
}
.main {
  position: relative;
  width: 100%;
  min-height: 14.25rem;
  padding-bottom: 1.6875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.count {
  position: absolute;
  bottom: 0.8rem;
  left: 0.8rem;
  color: wheat;
}
.showID {
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  color: gray;
}
.detail {
  position: absolute;
  bottom: 0.4rem;
  right: 1rem;
  z-index: 1000;
}
.tip {
  position: relative;
  margin: 2.5rem auto 0;
  width: 17.5rem;
  border: 1px solid #fbc27f;
}
.close {
  position: absolute;
  top: -0.9375rem;
  right: -0.9375rem;
  width: 2rem;
  height: 2rem;
  background-size: 100%;
}
.back {
  position: absolute;
  top: 0;
  right: 0;
  width: 44px;
  height: 44px;
  border-radius: 100%;
  padding: 8px;
  margin-top: 12px;
  margin-right: 12px;
  color: #b0726d;
}
.back-btn {
  margin-top: 1rem;
}
.alert {
  position: absolute;
  top: 6rem;
  left: 50%;
  transform: translate(-50%);
  width: 12rem;
}
/deep/.modal-body {
  position: relative;
  -ms-flex: 1 1 auto;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  padding: 0rem 1rem;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/deep/.modal-content {
  border-radius: 0.5rem;
  outline: 0;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.726);
  color: white;
  margin-top: 60%;
}
/deep/.modal-footer {
  border-top: 0px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/components/lucky.vue